// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MM_wrk_editor = require("../worker/MM_wrk_editor.bs.js");
var MM_syntax_tree = require("../mm-utils/MM_syntax_tree.bs.js");
var Expln_React_Row = require("@expln/utils/src/main/react-mui-components/Expln_React_Row.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var Expln_React_common = require("@expln/utils/src/main/Expln_React_common.bs.js");
var Paper = require("@mui/material/Paper").default;
var Select = require("@mui/material/Select").default;
var MenuItem = require("@mui/material/MenuItem").default;
var TextField = require("@mui/material/TextField").default;
var Save = require("@mui/icons-material/Save").default;
var IconButton = require("@mui/material/IconButton").default;
var FormControl = require("@mui/material/FormControl").default;
var CancelOutlined = require("@mui/icons-material/CancelOutlined").default;

function rndIconButton(icon, onClick, activeOpt, title, colorOpt, param) {
  var active = activeOpt !== undefined ? activeOpt : true;
  var color = colorOpt !== undefined ? Caml_option.valFromOption(colorOpt) : "primary";
  var tmp = {};
  if (title !== undefined) {
    tmp.title = Caml_option.valFromOption(title);
  }
  var tmp$1 = {
    onClick: (function (param) {
        Curry._1(onClick, undefined);
      }),
    disabled: !active,
    children: icon
  };
  if (color !== undefined) {
    tmp$1.color = color;
  }
  return React.createElement("span", tmp, React.createElement(IconButton, tmp$1));
}

function setNewText(st, text) {
  return {
          newText: text,
          infoExpanded: st.infoExpanded
        };
}

function setInfoExpanded(st, infoExpanded) {
  return {
          newText: st.newText,
          infoExpanded: infoExpanded
        };
}

function leftClickHnd(mouseEvt, clbk, ifNot) {
  if (mouseEvt.button === 0) {
    return Curry._1(clbk, undefined);
  } else {
    return Curry._1(ifNot, mouseEvt);
  }
}

function rndContText(stmtCont) {
  if (stmtCont.TAG === /* Text */0) {
    return stmtCont._0.map(function (stmtSym) {
                var color = stmtSym.color;
                return React.createElement(React.Fragment, {
                            children: color !== undefined ? React.createElement("span", {
                                    style: {
                                      color: color,
                                      fontWeight: "500"
                                    }
                                  }, stmtSym.sym + "\u00A0") : stmtSym.sym + "\u00A0",
                            key: stmtSym.id
                          });
              });
  } else {
    return MM_syntax_tree.syntaxTreeToSymbols(stmtCont._0).join(" ");
  }
}

var symbolsNotAllowedInLabelRegex = /[\s:]+/g;

function MM_cmp_user_stmt(Props) {
  var stmt = Props.stmt;
  var onLabelEditRequested = Props.onLabelEditRequested;
  var onLabelEditDone = Props.onLabelEditDone;
  var onLabelEditCancel = Props.onLabelEditCancel;
  var onTypEditRequested = Props.onTypEditRequested;
  var onTypEditDone = Props.onTypEditDone;
  var onContEditRequested = Props.onContEditRequested;
  var onContEditDone = Props.onContEditDone;
  var onContEditCancel = Props.onContEditCancel;
  var onJstfEditRequested = Props.onJstfEditRequested;
  var onJstfEditDone = Props.onJstfEditDone;
  var onJstfEditCancel = Props.onJstfEditCancel;
  var onGenerateProof = Props.onGenerateProof;
  var match = React.useState(function () {
        return {
                newText: "",
                infoExpanded: false
              };
      });
  var setState = match[1];
  var state = match[0];
  React.useEffect((function () {
          if (stmt.labelEditMode) {
            Curry._1(setState, (function (__x) {
                    return setNewText(__x, stmt.label);
                  }));
          } else if (stmt.typEditMode) {
            Curry._1(setState, (function (__x) {
                    return setNewText(__x, stmt.typ);
                  }));
          } else if (stmt.contEditMode) {
            Curry._1(setState, (function (__x) {
                    return setNewText(__x, MM_wrk_editor.contToStr(stmt.cont));
                  }));
          } else if (stmt.jstfEditMode) {
            Curry._1(setState, (function (__x) {
                    return setNewText(__x, stmt.jstfText);
                  }));
          }
          
        }), [
        stmt.labelEditMode,
        stmt.typEditMode,
        stmt.contEditMode,
        stmt.jstfEditMode
      ]);
  var actToggleInfoExpanded = function (param) {
    Curry._1(setState, (function (st) {
            return setInfoExpanded(st, !st.infoExpanded);
          }));
  };
  var actNewTextUpdated = function (newText) {
    Curry._1(setState, (function (__x) {
            return setNewText(__x, newText);
          }));
  };
  var actLabelEditDone = function (param) {
    Curry._1(onLabelEditDone, state.newText.replace(symbolsNotAllowedInLabelRegex, ""));
  };
  var actLabelEditCancel = function (param) {
    Curry._1(onLabelEditCancel, state.newText.replace(symbolsNotAllowedInLabelRegex, ""));
  };
  var actTypEditDone = function (newTypStr) {
    Curry._1(onTypEditDone, MM_wrk_editor.userStmtTypeFromStr(newTypStr));
  };
  var actContEditDone = function (param) {
    Curry._1(onContEditDone, state.newText.trim());
  };
  var actContEditCancel = function (param) {
    Curry._1(onContEditCancel, state.newText.trim());
  };
  var actJstfEditDone = function (param) {
    Curry._1(setState, (function (st) {
            return setInfoExpanded(st, true);
          }));
    Curry._1(onJstfEditDone, state.newText.trim());
  };
  var actJstfEditCancel = function (param) {
    Curry._1(onJstfEditCancel, state.newText.trim());
  };
  var rndLabel = function (param) {
    if (!stmt.labelEditMode) {
      return React.createElement("span", {
                  title: "<left-click> to change",
                  onClick: (function (__x) {
                      leftClickHnd(__x, onLabelEditRequested, (function (param) {
                              
                            }));
                    })
                }, stmt.label);
    }
    var partial_arg = actLabelEditCancel;
    var partial_arg$1 = actLabelEditDone;
    return React.createElement(Expln_React_Row.make, {
                children: null
              }, React.createElement(TextField, {
                    value: state.newText,
                    size: "small",
                    style: {
                      width: "100px"
                    },
                    onChange: (function (param) {
                        return Expln_React_common.evt2str((function (str) {
                                      var newText = str.replace(symbolsNotAllowedInLabelRegex, "");
                                      Curry._1(setState, (function (__x) {
                                              return setNewText(__x, newText);
                                            }));
                                    }), param);
                      }),
                    onKeyDown: (function (param) {
                        return MM_react_common.kbrdHnd(undefined, partial_arg$1, partial_arg, undefined, param);
                      }),
                    autoFocus: true,
                    title: "Ctrl+Enter to save, Esc to cancel"
                  }), rndIconButton(React.createElement(Save, {}), actLabelEditDone, state.newText.trim() !== "", "Save, Ctrl+Enter", undefined, undefined), rndIconButton(React.createElement(CancelOutlined, {}), actLabelEditCancel, undefined, "Cancel, Esc", Caml_option.some(undefined), undefined));
  };
  var rndCont = function (param) {
    if (!stmt.contEditMode) {
      return React.createElement(Paper, {
                  onClick: (function (__x) {
                      leftClickHnd(__x, onContEditRequested, (function (param) {
                              
                            }));
                    }),
                  style: {
                    backgroundColor: "rgb(255,255,235)",
                    padding: "1px 10px"
                  },
                  title: "<left-click> to change",
                  children: rndContText(stmt.cont)
                });
    }
    var partial_arg = actContEditCancel;
    var partial_arg$1 = actContEditDone;
    return React.createElement(Expln_React_Row.make, {
                children: null
              }, React.createElement(TextField, {
                    value: state.newText,
                    size: "small",
                    style: {
                      width: "600px"
                    },
                    multiline: true,
                    onChange: (function (param) {
                        return Expln_React_common.evt2str(actNewTextUpdated, param);
                      }),
                    onKeyDown: (function (param) {
                        return MM_react_common.kbrdHnd(undefined, partial_arg$1, partial_arg, undefined, param);
                      }),
                    autoFocus: true,
                    title: "Ctrl+Enter to save, Esc to cancel"
                  }), rndIconButton(React.createElement(Save, {}), actContEditDone, state.newText.trim() !== "", "Save, Ctrl+Enter", undefined, undefined), rndIconButton(React.createElement(CancelOutlined, {}), actContEditCancel, undefined, "Cancel, Esc", Caml_option.some(undefined), undefined));
  };
  var rndProofStatus = function (param) {
    var status = stmt.proofStatus;
    if (status !== undefined) {
      if (status === "ready") {
        return React.createElement("span", {
                    style: {
                      color: "green",
                      cursor: "pointer",
                      fontWeight: "bold"
                    },
                    title: "Proof is ready, left-click to generate compressed proof",
                    onClick: (function (param) {
                        Curry._1(onGenerateProof, undefined);
                      })
                  }, "\u2713");
      } else if (status === "noJstf") {
        return React.createElement("span", {
                    style: {
                      color: "red",
                      fontWeight: "bold"
                    },
                    title: "Justification cannot be determined automatically"
                  }, "?");
      } else if (status === "jstfIsIncorrect") {
        return React.createElement("span", {
                    style: {
                      color: "red",
                      fontWeight: "bold"
                    },
                    title: "Justification is incorrect"
                  }, "\u2717");
      } else {
        return React.createElement("span", {
                    style: {
                      color: "orange",
                      fontWeight: "bold"
                    },
                    title: "Justification for this statement is correct"
                  }, "\u223F");
      }
    } else {
      return null;
    }
  };
  var rndTyp = function (param) {
    if (stmt.typEditMode) {
      return React.createElement(FormControl, {
                  size: "small",
                  children: React.createElement(Select, {
                        value: "",
                        onChange: (function (param) {
                            return Expln_React_common.evt2str(actTypEditDone, param);
                          }),
                        children: null
                      }, React.createElement(MenuItem, {
                            value: "e",
                            children: "H"
                          }), React.createElement(MenuItem, {
                            value: "p",
                            children: "P"
                          }))
                });
    }
    var match = stmt.typ;
    var typStr = match === "p" ? "P" : "H";
    return React.createElement("span", {
                style: {
                  cursor: "pointer",
                  fontWeight: "bold"
                },
                title: "Alt+<left-click> to change statement type. Left-click to show/hide the justification for provable.",
                onClick: (function (__x) {
                    var ifNot = function (param) {
                      actToggleInfoExpanded(undefined);
                    };
                    if (__x.button === 0 && __x.altKey) {
                      return Curry._1(onTypEditRequested, undefined);
                    } else {
                      return Curry._1(ifNot, __x);
                    }
                  })
              }, typStr.toUpperCase());
  };
  var rndInfoBody = function (param) {
    if (stmt.typ === "p" && (state.infoExpanded || stmt.jstfEditMode)) {
      if (!stmt.jstfEditMode) {
        return React.createElement(Paper, {
                    onClick: (function (__x) {
                        leftClickHnd(__x, onJstfEditRequested, (function (param) {
                                
                              }));
                      }),
                    style: {
                      padding: "3px"
                    },
                    title: "<left-click> to change",
                    children: null
                  }, "Justification: ", stmt.jstfText);
      }
      var partial_arg = actJstfEditCancel;
      var partial_arg$1 = actJstfEditDone;
      return React.createElement(Expln_React_Row.make, {
                  children: null
                }, React.createElement(TextField, {
                      value: state.newText,
                      label: "Justification",
                      size: "small",
                      style: {
                        width: "600px"
                      },
                      multiline: true,
                      onChange: (function (param) {
                          return Expln_React_common.evt2str(actNewTextUpdated, param);
                        }),
                      onKeyDown: (function (param) {
                          return MM_react_common.kbrdHnd(undefined, partial_arg$1, partial_arg, undefined, param);
                        }),
                      autoFocus: true,
                      title: "Ctrl+Enter to save, Esc to cancel"
                    }), rndIconButton(React.createElement(Save, {}), actJstfEditDone, true, "Save, Ctrl+Enter", undefined, undefined), rndIconButton(React.createElement(CancelOutlined, {}), actJstfEditCancel, undefined, "Cancel, Esc", Caml_option.some(undefined), undefined));
    } else {
      return null;
    }
  };
  return React.createElement("table", undefined, React.createElement("tbody", undefined, React.createElement("tr", undefined, React.createElement("td", undefined, rndProofStatus(undefined)), React.createElement("td", undefined, rndLabel(undefined)), React.createElement("td", undefined, rndTyp(undefined)), React.createElement("td", undefined, rndCont(undefined))), React.createElement("tr", undefined, React.createElement("td", undefined, null), React.createElement("td", undefined, null), React.createElement("td", undefined, null), React.createElement("td", undefined, rndInfoBody(undefined)))));
}

var make = MM_cmp_user_stmt;

exports.make = make;
exports.rndContText = rndContText;
/* react Not a pure module */
